import { HTTP_TOKEN } from "./http";

export const Upload = (content, data, file_type) => {
  let formData = new FormData();
  formData.append("content", content);
  formData.append("file", data);
  formData.append("file_type", file_type);
  return HTTP_TOKEN.post("upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  }).then(result => {
    return result.data;
  });
};
